import React, { useRef } from 'react';

/** 3D tilt toward the mouse with a moving highlight, for glass cards (desktop pointers only). */
export default function Tilt({ children, className = '', max = 7, radius = 28, tone = 'red' }) {
  const ref = useRef(null);
  return (
    <div className={`pnp-tilt ${className}`.trim()}>
      <div
        ref={ref}
        className="pnp-tilt-inner"
        onPointerMove={(e) => {
          if (e.pointerType !== 'mouse') return;
          const el = ref.current;
          if (!el) return;
          const r = el.getBoundingClientRect();
          const px = (e.clientX - r.left) / r.width;
          const py = (e.clientY - r.top) / r.height;
          el.style.transitionDuration = '120ms';
          el.style.transform = `rotateX(${(0.5 - py) * max}deg) rotateY(${(px - 0.5) * max}deg)`;
          el.style.setProperty('--mx', `${px * 100}%`);
          el.style.setProperty('--my', `${py * 100}%`);
        }}
        onPointerLeave={() => {
          const el = ref.current;
          if (!el) return;
          el.style.transitionDuration = '700ms';
          el.style.transform = 'rotateX(0) rotateY(0)';
        }}
      >
        {children}
        <div aria-hidden="true" className={`pnp-tilt-shine${tone === 'gold' ? ' pnp-tilt-shine-gold' : ''}`} style={{ borderRadius: radius }} />
      </div>
    </div>
  );
}
